import { render, staticRenderFns } from "./form.page.vue?vue&type=template&id=6d44e161&scoped=true"
import script from "./form.page.vue?vue&type=script&lang=ts"
export * from "./form.page.vue?vue&type=script&lang=ts"
import style0 from "./form.page.vue?vue&type=style&index=0&id=6d44e161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d44e161",
  null
  
)

export default component.exports